// 首页列表组件
import * as React from 'react'
import HomeType from '../../types/HomeType'
import HomeItemTag from './HomeItemTag'
import * as Styles from './HomeItemListItem.style'
import { deletePictureParams, renderPopular, replaceWkDomain } from '../../../../utils/tools'
import { classes } from 'typestyle'
import { ImageView } from '../ImageView/ImageView'
import { reportClickEvent, ViewingMonitor, reAssemblyUbt } from '../../../../services/operationReport'
import { reportSetUbt } from '../../../../services/Modules/reportServer'
import style from './index.module.less'
// tslint:disable-next-line

interface HomeLimitBarProp {
  content: HomeType.Content
  topMargin?: number
  bottomMargin?: number
  moduleid: number
  moduleName: string
  index: number
}

function HomeItemListItem(props: HomeLimitBarProp) {
  const content = props.content
  const { moduleName, index, moduleid } = props

  const getDistance = {
    paddingTop: props.topMargin ? props.topMargin : '',
    paddingBottom: props.bottomMargin ? props.bottomMargin : ''
  }

  const renderTitleTag = () => {
    if (content.type && content.type === 'lecture' && !content.is_preffered) {
      renderLectureTag()
    } else {
      return
    }
  }

  const renderLectureTag = () => {
    if (content.lecture_mode === 'default') {
      switch (content.image_mode) {
        case 'video':
          return <HomeItemTag text={'视频'} />
        case 'audio':
          return <HomeItemTag text={'音频'} />
        case 'ppt':
          return <HomeItemTag text={'PPT'} />
        default:
          return true
      }
    } else {
      switch (content.lecture_mode) {
        case 'video':
          return <HomeItemTag text={'视频'} />
        case 'audio':
          return <HomeItemTag text={'音频'} />
        default:
          return true
      }
    }
  }

  const renderPrice = () => {
    if (content.stype === 'coupon') {
      return (
        <div className={Styles.couponTagSm}>
          <div className={Styles.couponTagSmText}>立减{content.meta && content.meta.desc}元</div>
        </div>
      )
    }
    if (content.need_money) {
      if (content.has_limitmoney) {
        if (Number(content.limit_money) === 0) {
          return (
            <p>
              <span>限时免费</span>
            </p>
          )
        } else {
          // tslint:disable-next-line
          return (
            <p>
              <i style={{ fontStyle: 'normal', fontSize: 12 }}>￥</i>
              {content.limit_money.split('.')[0]}
              <span>.{content.limit_money.split('.')[1]}</span>
            </p>
          )
        }
      } else {
        // tslint:disable-next-line
        return (
          <p>
            <i style={{ fontStyle: 'normal', fontSize: 12 }}>￥</i>
            {content.lecture_money.split('.')[0]}
            <span>.{content.lecture_money.split('.')[1]}</span>
          </p>
        )
      }
    } else {
      if (content.lecture_type !== 'pay_channel') {
        return <span className={Styles.HomeItemRightFreeLecture}>免费</span>
      } else {
        return null
      }
    }
  }

  const renderLectureTime = () => {
    if (content.lecture_mode === 'video' || content.lecture_mode === 'audio') {
      return (
        <p>
          时长<span>{content.audio_length}</span>分钟
        </p>
      )
    }

    if (content.status === 'closed') {
      if (content.audio_length <= 5) {
        return <p>{content.start_time.split(' ')[0]}</p>
      } else {
        return (
          <p>
            时长<span>{content.audio_length}</span>分钟
          </p>
        )
      }
    } else {
      return <p>{content.status_name}</p>
    }
  }

  const ifIsLivingStatus = () => {
    if (content.start_name === '正在直播') {
      return true
    } else {
      return false
    }
  }

  const gotoLink = React.useCallback((contents: HomeType.Content) => {
    const url = contents.stype === 'coupon' ? contents.url + `&${content.meta.params}` : contents.url
    reportClickEvent(`feed__${props.moduleid}`, {
      // event upload
      index,
      url,
      ch_id: contents.id,
      inviter_id: contents.inviter_id,
      context: moduleName
    })
    // HACK: add ubt
    const getUbt = reportSetUbt(`feed__${props.moduleid}`)
    // console.log(info.ubt, getUbt, `${url}&${getUbt}`)
    setTimeout(() => {
      window.location.assign(`${replaceWkDomain(url)}&${getUbt}`)
    }, 150)
  }, [])

  return (
    <ViewingMonitor
      ubt={reAssemblyUbt(`feed__${props.moduleid}`)}
      params={{
        index,
        url: content.url,
        ch_id: content.id,
        inviter_id: content.inviter_id,
        context: moduleName
      }}
    >
      <div onClick={() => gotoLink(content)} style={getDistance} className={[Styles.HomeItemListItem, style.HomeItemListItem].join(' ')}>
        <div className={style.liveroom}>
          <img className={style.photo} src={content.avatar_url || content.avatar} alt="" />
          <div className={style.text}>{content.liveroom_name}</div>
        </div>
        <a className={style.HomeItemListSubItem}>
          <div className={Styles.HomeItemLeft}>
            <div className={Styles.HomeItemLeftBgImage}>
              {window.location.pathname !== '/category' ? (
                <ImageView url={content.cover_url ? content.cover_url : content.cover} width={300} />
              ) : (
                <picture>
                  <source
                    type="image/webp"
                    srcSet={
                      content.cover_url
                        ? `${deletePictureParams(content.cover_url)}?imageView2/format/webp/2/w/300/q/85!`
                        : `${deletePictureParams(content.cover)}?imageView2/format/webp/2/w/300/q/85!`
                    }
                  />
                  <img
                    src={
                      content.cover_url ? `${deletePictureParams(content.cover_url)}?imageView2/2/w/300/q/85!` : `${deletePictureParams(content.cover)}?imageView2/2/w/300/q/85!`}
                    alt=""
                  />
                </picture>
              )}
            </div>

            <div className={Styles.StudyTotalNum}>
              <div className={Styles.StudyTotalNumDiv}>
                <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt="" />
                {renderPopular(content.popular)}人
              </div>
            </div>
            {content.stype === 'coupon' && (
              <div>
                <div className={Styles.couponTagBig} />
                <div className={Styles.couponTagBigText}>
                  <p>立减</p>
                  <p>
                    <span>{content.meta && content.meta.desc}</span>
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className={Styles.HomeItemRight}>
            <div className={classes(Styles.HomeItemRightTitle, 'TextChangeToTwoLines')}>
              {content.is_preffered && (
                <div className={Styles.youXuanType}>
                  <img src="https://static-cos.lycheer.net/picture/10490565_2851c8d7884e28dd13a5119f3f0afe89.jpg" alt="" />
                </div>
              )}
              {content.type && content.type === 'lecture' && !content.is_preffered && renderLectureTag()}
              {content.name ? content.name : content.title}
            </div>

            <div className={Styles.HomeItemLeftBottom}>
              <div className="currency-item-right-bottom_left-count-time" style={{ color: '#999999' }}>
                {content.type && content.type === 'channel' && !ifIsLivingStatus() && (
                  <p>
                    已更新<span>{content.current_status_display.replace('已更新', '').replace('期', '').replace('节课程', '').replace('含', '')}</span>期
                  </p>
                )}
                {content.type && content.type === 'lecture' && !ifIsLivingStatus() && renderLectureTime()}
                {ifIsLivingStatus() && (
                  <div className="HomeItemLeftBottom">
                    <div className={Styles.isLivingText}>
                      <img className={Styles.LiveStatusImg} src="https://static-cos.lycheer.net/picture/7931794_e27bd04f8061e533ae1851e0928b2f50.jpg" alt="" />
                      正在直播
                    </div>
                  </div>
                )}
              </div>

              <div className={Styles.HomeItemRightBotton}>
                {content.type && content.type === 'lecture' && (
                  <div className={Styles.HomeItemRightBottonRight}>
                    {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' && (
                      <p className="HomeItemRightBottonRightLimit">
                        <del>￥{content.lecture_money}</del>
                      </p>
                    )}
                    {renderPrice()}
                  </div>
                )}
                {content.type && content.type === 'channel' && (
                  <div className={Styles.HomeItemRightBottonRight}>
                    {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' && (
                      <p className="HomeItemRightBottonRightLimit">
                        <del>￥{content.lecture_money}</del>
                      </p>
                    )}
                    {renderPrice()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </a>
      </div>
    </ViewingMonitor>
  )
}

export default HomeItemListItem



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeItemListItem/HomeItemListItem.tsx